module.exports = __webpack_public_path__ + "img/madnessBanner_600.ff6eba3d.png";